import { Button, Typography, Box } from '@mui/material';
import { useHistory } from 'react-router';
// Utils and Helpers
import { APP_ROUTES } from 'routes';
// Assets
import { ReactComponent as NotFound } from 'assets/pages/NotFound.svg';

export const NotFoundPage = () => {
    const history = useHistory();
    return (
        <Box
            style={{
                backgroundColor: '#F2F2F2',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                height: '100vh'
            }}>
            <NotFound />
            <Typography
                sx={{
                    fontWeight: '700',
                    fontSize: '2em',
                    color: '#182D55'
                }}>
                Page not found
            </Typography>
            <Typography
                sx={{
                    fontWeight: '500',
                    fontSize: '1.4em',
                    color: '#182D55'
                }}>
                The page you are looking for does not exist
            </Typography>
            <Button
                sx={{
                    marginTop: '1em',
                    color: 'white',
                    backgroundColor: '#1BABE2',
                    padding: '1em',
                    borderRadius: '4px'
                }}
                onClick={() => history.push(APP_ROUTES.DASHBOARD)}>
                Back to overview
            </Button>
        </Box>
    );
};
